(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/payfooter.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/payfooter.js');

'use strict';

const {
  useSelector
} = ReactRedux;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const ReactPayfooter = svs.tur.ReactPayfooter;
const Payfooter = _ref => {
  let {
    onPay
  } = _ref;
  const {
    activeBalance,
    isSyndicate
  } = useSelector(state => state.account);
  const sizes = useSelector(state => state.gamePackage.sizes);
  const activeIndex = useSelector(state => state.gamePackage.activeIndex);
  const packageIsClosed = useSelector(state => state.gamePackage.packageIsClosed);
  const packageLabel = useSelector(state => state.gamePackage.title);
  return React.createElement("div", {
    className: "gp-payfooter"
  }, React.createElement(ReactPayfooter.Payfooter, {
    isFixed: isSelfService,
    isBottom: false,
    sum: sizes[activeIndex].price,
    isShowingSum: !isSelfService,
    balance: activeBalance,
    balanceLabel: isSyndicate ? 'Vårt saldo' : 'Mitt saldo',
    buttons: [{
      pay: true,
      onClick: onPay,
      disabled: packageIsClosed
    }],
    reminderTrackingLabel: packageLabel
  }));
};
svs.gamePackage.components.Payfooter = Payfooter;

 })(window);